import axios from 'axios'
import { getAuthorizationToken } from './utils/jwtToken'

const formatAuthToken = (token: string | undefined): string | undefined => {
  if (!token) return undefined
  // Add Bearer prefix if not already present
  return token.startsWith('Bearer ') ? token : `Bearer ${token}`
}

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Authorization: formatAuthToken(getAuthorizationToken()),
    Accept: 'application/json',
  },
})

// Request interceptor to always read token from localStorage on each request
httpClient.interceptors.request.use(
  (config) => {
    const token = getAuthorizationToken()
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = formatAuthToken(token)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export const httpClientWithBlob = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Authorization: formatAuthToken(getAuthorizationToken()),
    // Accept: 'multipart/form-data',
    'Content-Type': 'multipart/form-data',
  },
})

// Request interceptor for blob client too
httpClientWithBlob.interceptors.request.use(
  (config) => {
    const token = getAuthorizationToken()
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = formatAuthToken(token)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default httpClient
